exports.AgGridReact = require('./lib/agGridReact').AgGridReact;
exports.ChangeDetectionStrategyType = require('./lib/shared/interfaces').ChangeDetectionStrategyType;
exports.AgGridReactUi = require('./lib/reactUi/agGridReactUi').AgGridReactUi;
